/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

/**
 *
 * AgentAssistForm
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Button, DetailHeader, InputField } from 'cx-ui-components';
import DetailWrapper from '../../../../components/DetailWrapper';
import styled from 'styled-components';

const WrappedDetailHeader = styled(DetailHeader)`
  margin-left: 35px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 8px 0 0 8px;
  box-sizing: border-box;
`;

const UrlFieldWrapper = styled.div`
  min-height: 68px;
`;

export default function AgentAssistForm({ isSaving, inherited, userHasUpdatePermission, initialValues, integrationActive }) {
  const savedAgentAssistUrl = initialValues?.getIn?.(['properties', 'agentAssistUrl']);
  const isIntegrationEnabled = !!integrationActive;
  const openKnowledgebase = (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }

    if (!isIntegrationEnabled) {
      return;
    }

    const baseUrl = (savedAgentAssistUrl || '').trim().replace(/\/+$/, '');

    if (!baseUrl) {
      return;
    }

    window.open(`${baseUrl}/mgr`, '_blank', 'noopener,noreferrer');
  };

  return (
    <DetailWrapper open data-automation="agentAssistPropertiesSVG">
      <WrappedDetailHeader text="Properties" />
      <UrlFieldWrapper>
        <InputField
          name="properties.agentAssistUrl"
          label="URL "
          componentType="input"
          inputType="text"
          data-automation="integrationsAgentAssistUrl"
          disabled={isSaving || inherited || !userHasUpdatePermission}
        />
      </UrlFieldWrapper>
      <ButtonWrapper>
        <Button
          buttonType="primary"
          onClick={openKnowledgebase}
          data-automation="btnManageKnowledgebase"
          disabled={isSaving || inherited || !userHasUpdatePermission || !savedAgentAssistUrl || !isIntegrationEnabled}
        >
          Manage Knowledgebase
        </Button>
      </ButtonWrapper>
    </DetailWrapper>
  );
}

AgentAssistForm.propTypes = {
  isSaving: PropTypes.bool,
  inherited: PropTypes.bool,
  userHasUpdatePermission: PropTypes.bool,
  initialValues: PropTypes.object,
  integrationActive: PropTypes.bool
};
